import RawHtml from '@components/RawHtml';

type Props = {
  title: string;
  subtitle?: string | null;
  hasBannerImage?: boolean;
};

function Hero(props: Props) {
  const { title, subtitle, hasBannerImage = false } = props;

  return (
    <div className={`hero${hasBannerImage ? '' : ' hero--no-image'}`}>
      <div className='container'>
        <div className='hero__wrapper'>
          {title ? <h1 className='hero__title'>{title}</h1> : null}
          {subtitle ? <RawHtml className='hero__subtitle' html={subtitle} /> : null}
        </div>
      </div>
    </div>
  );
}

export default Hero;
